module.exports = __webpack_public_path__ + "static/media/theme-color-hint-1.14fed44e.png";